import React, { useState, useRef, useEffect } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { Grid, Box, Typography, Button } from "@mui/material";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import { Link } from "react-router-dom";
import apiAuth from "../../helpers/ApiAuth";
import { Row, Col } from "reactstrap";
import QRCode from "qrcode.react";
import { CheckCircle, CurrencyRupee } from "react-bootstrap-icons";
import NewHeader from "../../Layouts/NewHeader";
import NewFooter from "../../Layouts/NewFooter";

const ViewDetails = () => {
  const [transactionData, setTransactionData] = useState({
    amount: 2000,
    id: "123456789",
    userName: "John Doe",
    mobile: "1234567890",
    transactionDate: "2023-11-14",
  });
  const location = useLocation();
  const { id } = useParams();
  console.log("params", id);
  const history = useHistory();

  const getTransactionDetails = (id) => {
    apiAuth
      .get(`/api/Transaction/History/${id}`)
      .then((res) => {
        const { data } = res;
        setTransactionData(data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    // let params = new URLSearchParams(location?.search);
    // let id = params.get("transaction_id");
    if (id) {
      getTransactionDetails(id);
    }
  }, []);
  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh", overflowX: "hidden" }}
      >
        <NewHeader />
        <div
          className="mt-4 p-5"
          style={{
            background:
              "linear-gradient(180deg, rgba(23, 0, 0, 0.80) 28.15%, rgba(0, 11, 5, 0.80) 99.2%)",
            backdropFilter: "blur(30px)",
          }}
        >
          <h5 style={{ color: "#FFF", fontSize: "25px", fontWeight: "700" }}>
            Prepaid Electricity Recharge
          </h5>
        </div>
        <div className="container mx-1" style={{ flex: "1" }}>
          <Grid container>
            <Grid item lg={8} xs={12}>
              <div
                className="card px-5 py-5 my-3 mx-2 m-auto shadow-lg position-relative"
                style={{
                  top: "-40px",
                  borderRadius: "10px",
                  margin: "auto !important",
                }}
              >
                <Row className="mb-4" style={{ placeItems: "center" }}>
                  <Col lg={6}>
                    <div className="d-flex align-items-center gap-3 justify-content-start">
                      <CheckCircle
                        size={50}
                        color="green"
                        className="rounded-circle"
                      />
                      <h1
                        style={{
                          // fontSize: "20px",
                          margin: "0px",
                          fontWeight: "600",
                          color: "#000",
                        }}
                      >
                        <CurrencyRupee />
                        2000
                      </h1>
                    </div>
                    <p
                      className="mt-2 mb-4"
                      style={{
                        fontSize: "16px",
                        margin: "0px",
                        fontWeight: "400",
                      }}
                    >
                      Your Payment is successfully done!
                    </p>

                    <Button
                      className="btn my-2 w-50"
                      onClick={() => {
                        history.push("/dashboard");
                      }}
                      style={{
                        color: "black",
                        fontWeight: 500,
                        fontSize: "15px",
                        background: "#D3D3D3",
                        borderRadius: "5px",
                        boxShadow:
                          "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                        textTransform: "capitalize",
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.background = "darkgrey")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.background = "lightgrey")
                      }
                    >
                      Home
                    </Button>
                  </Col>
                  {/* </Row>
                <Row> */}
                  <Col lg={6} xs={12} className="text-start">
                    <div className="text-center d-flex align-items-center justify-content-center">
                      <QRCode
                        value={`${transactionData.amount}_${transactionData.id}_${transactionData.userName}_${transactionData.mobile}_${transactionData.transactionDate}`}
                        // value={`<b>Amount:</b> ${transactionData.amount} USD\n<b>Recipient:</b> ${transactionData.recipient}\n<b>Transaction ID:</b> ${transactionData.id}\n<b>Currency:</b> ${transactionData.currency}\n<b>Additional Info:</b> ${transactionData.additionalInfo || ""}`}
                        width={100}
                        className=""
                      />
                    </div>
                    <p className="text-center mt-4 mb-1">Nov 2, 14:54</p>
                    <p className="text-center mb-1">Txn ID: 1253654348958</p>
                  </Col>
                </Row>
              </div>
            </Grid>
          </Grid>
        </div>
        <NewFooter />
      </div>
    </>
  );
};

export default ViewDetails;
